import React from 'react'
import styled from 'styled-components'
import { Layout, Menu, Switch } from 'antd';
import {
  CreditCardOutlined,
    SettingOutlined,
    ReadOutlined,
    
    PhoneOutlined,
    ScheduleOutlined,
    TeamOutlined,
    SnippetsFilled,
    AppstoreFilled,
    GlobalOutlined,
    CodeSandboxOutlined,
    CodeSandboxSquareFilled,
    UsergroupAddOutlined,
    ProfileOutlined ,
    TagOutlined 
  } from '@ant-design/icons';
import {Link, useLocation} from 'react-router-dom'
import Logo from './images/SonaLogo.png'


const {  Sider } = Layout;
const { SubMenu } = Menu;

export default function Sidebar({click, color, collapsed}) {


  const {pathname} = useLocation()
  console.log(pathname);

    return (
   <SideMenuWrap color={color}>
             <Sider trigger={null} collapsible collapsed={collapsed}>

             <div className="" >
            {
              collapsed ? <img src={Logo} className="d-block mx-auto" width="70px" alt="logo"/> :

              <img src={Logo} className="d-block mx-auto" width="130px" alt="logo"/>
            }
            </div>


          <Menu
           theme={color? 'dark' : 'light'}
           mode="inline"
           defaultSelectedKeys={[pathname]}
           className="menu"
          //  selectedKeys={[pathname]}

          >
           
          <Menu.Item key="admin/blog" icon={<ReadOutlined />} >
          <Link to="/admin/blog">Blog</Link>
            </Menu.Item>

            <Menu.Item key="admin/news" icon={<GlobalOutlined />} >
          <Link to="/admin/news">News</Link>
            </Menu.Item>

            <Menu.Item key="admin/events" icon={<ScheduleOutlined />} >
          <Link to="/admin/events">Events</Link>
            </Menu.Item>

            <Menu.Item key="admin/jobs" icon={<TeamOutlined />} >
            <Link to="/admin/jobs">Jobs</Link>
            </Menu.Item>

            <Menu.Item key="admin/subscribe" icon={<TeamOutlined />} >
            <Link to="/admin/subscribers">Subscribers</Link>
            </Menu.Item>

            <Menu.Item key="admin/resume" icon={<ProfileOutlined />} >
            <Link to="/admin/resume">Job Applications</Link>
            </Menu.Item>

            <Menu.Item key="admin/enquiry" icon={<PhoneOutlined />} >
            <Link to="/admin/enquiry">Enquiry</Link>
            </Menu.Item>
          
      
          </Menu>
          {/* <div className="mode">
         <Switch checkedChildren="Dark" unCheckedChildren="Light" onChange={()=>click()} />
          </div> */}
        </Sider>
        </SideMenuWrap>
      
    )
}


const SideMenuWrap = styled.div`



.menu{


font-size:1rem;
svg{

  font-size:1.1rem;
  transform:translate(-5px, -4px);
}

}

.mode{

position:absolute;
bottom:5%;
left:10%;

.ant-switch{

  background-color:${props=>props.color? "grey":"#1890FF"};
}
}


`